import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { greenIDApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${greenIDApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
